import { useEffect, useRef, useState } from "react";
import { ProductCategoriesViewModel } from "../../viewmodels/primaryCategories/ProductCategoriesViewModel";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import * as actions from "../../store/actions/index";
import { withRouter } from "../../shared/utility";

// Template Components
import DataManagementTemplate from "../../components/templates/DataManagementTemplate";
import MobileCardsTemplate from "../../components/templates/MobileCardsTemplate";

import SlideOver from "../../components/slideOver/SlideOver";
import EmptyModal from "../../components/modals/EmptyModal";

function ProductCategories(props) {
  const { logout } = props;
  const navigate = useNavigate();
  const {
    emptyModal,
    setEmptyModelOpen,
    getProductCategories,
    loading,
    primaryCategories,
    setSlideOver,
    slideOver,
  } = ProductCategoriesViewModel(logout);

  const [currentPage, setCurrentPage] = useState(1);
  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    getProductCategories(null, currentPage);
  }, []);

  const searchRef = useRef();

  // Search handler
  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1);
    getProductCategories(term || null, 1);
  };

  // Pagination handler
  const handlePageChange = (event) => {
    const newPage = event.page + 1;
    setCurrentPage(newPage);
    setFirst(event.first);
    setRows(event.rows);
    getProductCategories(searchTerm || null, newPage);
  };

  // Row click handler
  const handleRowClick = (category) => {
    navigate(`/primary-categories/${category.id}`);
  };

  // Button configurations
  const headerButtons = [
    {
      label: "Add category",
      onClick: () => {
        navigate("/primary-categories/new");
      },
      className: "bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white focus:ring-primary-500"
    }
  ];

  // Column configurations for DataTable
  const columns = [
    {
      field: "name",
      header: "Category Name",
      style: { width: '90%' },
      body: (rowData) => (
        <span className="font-semibold apollo-subheading text-gray-900">
          {rowData.name}
        </span>
      )
    },
    {
      header: "Actions",
      style: { width: '10%' },
      body: (rowData) => (
        <Link
          className="inline-flex items-center justify-center px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          to={`/primary-categories/${rowData.id}`}
        >
          View
        </Link>
      )
    }
  ];

  // Mobile cards component
  const CategoriesMobileCards = ({ data }) => (
    <MobileCardsTemplate
      data={data}
      onCardClick={(category) => navigate(`/primary-categories/${category.id}`)}
      onEdit={(category) => navigate(`/primary-categories/${category.id}`)}
      editRoute="/primary-categories"
      emptyMessage="No categories found"
      cardContent={(category) => (
        <div className="flex flex-col space-y-3">
          {/* Header */}
          <div className="flex justify-between items-start">
            <div>
              <h3 className="text-h6 apollo-heading text-primary-600 mb-1">
                {category.name}
              </h3>
            </div>
          </div>
        </div>
      )}
      actionButtons={(category) => (
        <div className="flex gap-2 pt-2" onClick={(e) => e.stopPropagation()}>
          <Link to={`/primary-categories/${category.id}`} className="flex-1">
            <button
              className="w-full inline-flex items-center justify-center px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            >
              View
            </button>
          </Link>
        </div>
      )}
    />
  );

  return (
    <div>
      <DataManagementTemplate
        title="Product Categories"
        description="Manage your product categories"
        headerButtons={headerButtons}
        columns={columns}
        data={primaryCategories.data || []}
        loading={loading}
        pagination={{
          first: first,
          rows: rows,
          total: primaryCategories.total || 0,
          template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
          currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} categories"
        }}
        onSearch={handleSearch}
        onPageChange={handlePageChange}
        onRowClick={handleRowClick}
        searchPlaceholder="Search by category"
        MobileCardsComponent={CategoriesMobileCards}
        emptyMessage="No categories found"
      />
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductCategories)
);
